<div class="video-container">
    <button class="close-button" (click)="dialogRef.close()">
        <i class="material-icons">close</i>
    </button>
    <iframe
        [src]="getVideoUrl() | safe"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen>
    </iframe>
</div>
